(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banarasi-edit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-banarasi-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-banarasi-track]');
    const previous = slider.querySelector('[data-banarasi-previous]');
    const next = slider.querySelector('[data-banarasi-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      const maximum = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridal-edit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bridal-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-bridal-track]');
    const previous = slider.querySelector('[data-bridal-prev]');
    const next = slider.querySelector('[data-bridal-next]');
    if (!track || !previous || !next) return;
    const update = () => { const maximum = track.scrollWidth - track.clientWidth; previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= maximum - 2; };
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1)); track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-campaign-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.concept-campaign').forEach((campaign) => {
    const slides = Array.from(campaign.querySelectorAll('.concept-campaign__slide'));
    const dots = Array.from(campaign.querySelectorAll('[data-campaign-index]'));
    const previous = campaign.querySelector('.concept-campaign__previous');
    const next = campaign.querySelector('.concept-campaign__next');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!reducedMotion) timer = window.setInterval(() => showSlide(activeIndex + 1), 7000);
    };

    previous.addEventListener('click', () => { showSlide(activeIndex - 1); start(); });
    next.addEventListener('click', () => { showSlide(activeIndex + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.campaignIndex)); start(); }));
    campaign.addEventListener('mouseenter', stop);
    campaign.addEventListener('mouseleave', start);
    campaign.addEventListener('focusin', stop);
    campaign.addEventListener('focusout', start);
    showSlide(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-editorial-concept"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    const previous = slider.querySelector('[data-slider-previous]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track || !previous || !next) return;

    const updateControls = () => {
      const maximum = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    };

    const move = (direction) => {
      track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patola-edit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-patola-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-patola-track]');
    const previous = slider.querySelector('[data-patola-prev]');
    const next = slider.querySelector('[data-patola-next]');
    if (!track || !previous || !next) return;
    const update = () => { const maximum = track.scrollWidth - track.clientWidth; previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= maximum - 2; };
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1)); track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-love-this-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-pdp-event="recommendation_click"]');
    if (!target) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pdp_recommendation_click',
      product_handle: target.dataset.productHandle,
      recommended_product: target.dataset.recommendedProduct,
      recommendation_source: target.dataset.recommendationSource
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
